import PropTypes from 'prop-types'
import { Typography } from '@mui/joy'
import { formatMoney } from 'utils/helpers'

const Salary = ({ task }) => (
  <Typography level="body-xs">
    {formatMoney(task.computedSalary)}
    {task.bonusRate && (
      <Typography display="block" color="success" fontSize={11} lineHeight={1.2}>
        + {formatMoney(task.bonusRate)}
      </Typography>
    )}
  </Typography>
)

Salary.propTypes = {
  task: PropTypes.shape({
    computedSalary: PropTypes.number,
    bonusRate: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
}

export default Salary
